import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { authAtom } from "stores";
import { useSetRecoilState } from "recoil";
import { loginToCtoAccountResponse } from "./helper";
import { urlMaker } from "utils";

const loginToCtoAccount = async (data: { id: number }) =>
  axios.put(urlMaker("cto", data?.id, "login-as-user"));

export const useLoginToCtoAccount = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.LOGIN_TO_CTO_ACCOUNT_MUT],
    mutationFn: loginToCtoAccount,
    onSuccess: (res) => loginToCtoAccountResponse({ auth: res.data, setAuth }),
  });
};
